// @flow strict
import type { $AxiosXHR } from 'axios'
import axios from 'axios'
import { identity, memoizeWith } from 'ramda'
import { Partner } from './partner'
import type { Grade } from './ald-types'

export const getStateAldData: (Partner) => Promise<Grade[]> = memoizeWith(
  identity,
  (partner) => {
    return axios
      .get(`/data/${(partner:string)}/ald-data.json`)
      .then((response: $AxiosXHR<mixed, Grade[]>) => {
        return response.data;
      })
      .catch((error) => {
        console.error(`Error loading ${(partner:string)} ALD data`, error);
        return [];
      });
  }
);
